import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";

import {
  updateParams as updateInfluencerParams,
  updateInfluencerPageState,
} from "../Pages/Influencer/influencer_actions";
import {
  updateParams as updateProductParams,
  updateProductPageState,
} from "../Pages/Product/productActions";
import {
  updateVideoPageState,
  updateParams as updateVideoParams,
  updatePublishedPageState,
  doResetFiltersVideos,
  updateCampaignState,
} from "../Pages/Video/VideoActions";
import { numString } from "../utilities";
import { identifyAccosiactedTab } from "./SharedActions";
import "./shared.scss";
import { updateTab } from "../Pages/Reports/ReportActions";
import { fetchNotes } from "./Notes/NoteActions";
import Cookies from "js-cookie";
import CampaignBreadcrumbs from "../Pages/Video/Components/Campaign/CampaignBreadcrumbs";

const GenerateBreadCrumbs = ({ indexName }) => {
  const videoParams = useSelector((state) => state.videoParams);
  const videoDetailBreadcrumb = useSelector(
    (state) => state.VideoDetailBreadcrumb
  );
  const campaignBreadcrumbs = useSelector(
    (state) => state.videoPageStates.campaignsState.breadcrumbs
  );

  const videoPageStates = useSelector((state) => state.videoPageStates);
  const isCampaignListPage = useSelector(
    (state) => state.videoPageStates.isCampaignListPage
  );
  const productPageStates = useSelector((state) => state.productPageStates);
  const PublishedPageStates = useSelector((state) => state.PublishedPageStates);
  const InfluencerPageStates = useSelector(
    (state) => state.InfluencerPageStates
  );
  const productParams = useSelector((state) => state.productParams);
  const productData = useSelector((state) => state.productData);
  const influencerParams = useSelector((state) => state.influencerParams);
  const influencerData = useSelector((state) => state.influencerData);
  const videoData = useSelector((state) => state.videoData);
  const videoDataLoading = useSelector((state) => state.videoData.loading);
  const [isDetailPage, setIsDetailPage] = useState(false);
  const [assosiatedTab, setAssosiatedTab] = useState("");
  const [loading, setLoading] = useState(false);
  const [getDataFromRedux, setGetDataFromRedux] = useState(true);
  const [hideBreadcrumb, setHideBreadcrumb] = useState(false);

  const isFlaggedTab = useSelector((state) => state.videoParams.isFlaggedTab);
  const videoFavoriteTab = useSelector(
    (state) => state.videoParams.isFavoriteTab
  );
  const productFavoriteTab = useSelector(
    (state) => state.productParams.isFavoriteTab
  );
  const isTrashTab = useSelector((state) => state.productParams.isTrashTab);
  const isVideoTrashTab = useSelector((state) => state.videoParams.isTrashTab);
  const isCampaignTab = useSelector((state) => state.videoParams.isCampaignTab);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const { id } = useParams();

  const fetchTabDetails = () => {
    const generateUrl = {
      Products: `/products/${id}/identify_my_or_competitor_product`,
      Videos: `/videos/${id}/identify_my_or_competitor_video`,
      Published: `/videos/${id}/identify_my_or_competitor_video`, //@TODO CALL
    };
    setLoading(true);
    identifyAccosiactedTab(generateUrl[indexName])
      .then((response) => {
        setLoading(false);
        setAssosiatedTab(response[0]);
        setHideBreadcrumb(false);
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setHideBreadcrumb(true);
        }
        setLoading(false);
      });
  };

  useEffect(() => {
    if (location.pathname) setIsDetailPage(id ? true : false);
  }, [location.pathname]);

  useEffect(() => {
    if (
      (isDetailPage && indexName === "Published" && videoData.count < 1) ||
      (isDetailPage && indexName === "Products" && productData.count < 1)
    ) {
      setGetDataFromRedux(false);
      fetchTabDetails();
    }
  }, [productData.count, videoData.count, isDetailPage]);

  const isCategoryActive = {
    Products: productPageStates.isCategoryPage,
    Videos: videoPageStates.isCategoryPage,
    influencers: InfluencerPageStates.isCategoryPage, //@TODO
    Published: PublishedPageStates.isCategoryPage, //@TODO
  };
  // console.log(videoPageStates.isCategoryPage, isCampaignListPage);
  const dispatchActiveParams = {
    Products: () => dispatch(updateProductPageState({ isCategoryPage: true })),
    Videos: () => {
      dispatch(
        updateVideoPageState({
          isCategoryPage: true,
          isCampaignListPage: false,
        })
      ),
        dispatch(
          updateCampaignState({ breadcrumbs: [], showCampaignHeader: false })
        );
      Cookies.remove("activeTab");
      navigate("/videos");
    },
    Published: () =>
      dispatch(updatePublishedPageState({ isCategoryPage: true })),
    influencers: () =>
      dispatch(updateInfluencerPageState({ isCategoryPage: true })),
  };

  const dispatchFromDetails = {
    Products: () => {
      navigate("/products");
      dispatch(updateProductPageState({ isCategoryPage: true }));
    },
    Videos: () => {
      navigate("/videos");
      dispatch(updateVideoPageState({ isCategoryPage: true }));
      dispatch(updateCampaignState({ breadcrumbs: [] }));
    },

    Published: () => {
      navigate("/published");
      dispatch(updatePublishedPageState({ isCategoryPage: true }));
    },
  };

  const ActiveTab = {
    Products: productParams.tab,
    Videos: videoParams.tab,
    influencers: influencerParams.tab,
    Published: videoParams.tab,
  };

  const tabAsParamName = {
    my_product: "My Products",
    competitor_product: "Competition",
    my_video: "My Videos",
    competitor_video: "Competition",
    my_influcencers: "My Creators",
  };

  const tabAsInBreadcrumb = {
    my_product: "My Products",
    competitor_product: "Competitors",
    my_video: "My Videos",
    competitor_video: "Competitors",
    my_influcencers: "My Creators",
  };

  const ActiveCard = {
    Products: () => {
      navigate("/products");
      dispatch(
        updateProductParams({
          tab: getDataFromRedux
            ? productParams.tab
            : tabAsParamName[assosiatedTab],
        })
      );
      dispatch(updateProductPageState({ isCategoryPage: false }));
    },
    influencers: () => {
      navigate("/influencers");
      dispatch(
        updateInfluencerPageState({
          isCategoryPage: false,
        })
      );
    },
    Videos: () => {
      navigate("/videos");
      dispatch(
        updateVideoParams({
          tab: getDataFromRedux
            ? videoParams.tab
            : tabAsParamName[assosiatedTab],
        })
      );
      dispatch(updateVideoPageState({ isCategoryPage: false }));
    },

    Published: () => {
      navigate("/published");
      dispatch(
        updateVideoParams({
          tab: getDataFromRedux
            ? videoParams.tab
            : tabAsParamName[assosiatedTab],
          isCategoryPage: false,
        })
      );
    },
  };

  const ActiveCount = {
    Products: productData.count,
    Videos: videoData.count,
    influencers: influencerData.count,
    Published: videoData.count,
  };

  const ActiveProduct = {
    Products: "Product",
    Videos: "Video",
    Published: "Video",
  };

  const UIConstants = () => {
    // @TODO need improvements
    if (
      ActiveTab[indexName] === "Competition" &&
      !isTrashTab &&
      !productFavoriteTab &&
      !isFlaggedTab &&
      !videoFavoriteTab &&
      !isVideoTrashTab
    ) {
      return "Competitors";
    }
    if (ActiveTab[indexName] === "fan") {
      return "Shopper";
    }
    if (isFlaggedTab) {
      return "Flagged Videos";
    }
    if (isCampaignTab || isCampaignListPage) {
      return "Campaigns";
    }
    if (isTrashTab || isVideoTrashTab) {
      return "Trash";
    }
    if (videoFavoriteTab && indexName === "Videos") {
      return "Favorites Videos";
    }
    if (productFavoriteTab && indexName === "Products") {
      return "Favorites Products";
    }
    return ActiveTab[indexName];
  };

  const renderIndexName = () => {
    if (indexName === "influencers") {
      return "Creators";
    }
    if (indexName === "Published") {
      return "Published Videos";
    }
    return indexName;
  };

  const renderIndexCrumbs = (
    <>
      {!isCategoryActive[indexName] && (
        <div>
          <img
            src={require("@images/videos/expand-right-icon.png").default}
            width={9}
          />
        </div>
      )}
      {!isCategoryActive[indexName] && ActiveTab[indexName] && (
        <div>
          <span className="ActiveTab text-capitalize">
            {UIConstants()}
            {/* TODO: video */}
            {!isCampaignListPage &&
              indexName === "Videos" &&
              !videoDataLoading &&
              ` (${numString(ActiveCount[indexName])})`}

            {/* {indexName === "Videos" &&
              !videoDataLoading &&
              ` (${numString(ActiveCount[indexName])})`} */}
            {indexName !== "Videos" &&
              ` (${numString(ActiveCount[indexName])})`}
          </span>
        </div>
      )}
    </>
  );

  const renderDetailsCrumbs = !loading && !hideBreadcrumb && (
    <>
      <div>
        <img
          src={require("@images/videos/expand-right-icon.png").default}
          width={9}
        />
      </div>
      <div>
        <span
          className="ActivePage text-capitalize"
          role="button"
          onClick={ActiveCard[indexName]}
        >
          {getDataFromRedux ? UIConstants() : tabAsInBreadcrumb[assosiatedTab]}
        </span>
      </div>
      <div>
        <img
          src={require("@images/videos/expand-right-icon.png").default}
          width={9}
        />
      </div>
      <div>
        <span className="ActiveTab">{ActiveProduct[indexName]} Details</span>
      </div>
    </>
  );

  if (
    (location.pathname.includes("videos") ||
      location.pathname.includes("published")) &&
    id
  ) {
    const arr = [];
    let recent = false;
    videoDetailBreadcrumb.forEach((i) => {
      // if (i.name === "Home") recent = true;
      arr.push(
        <div
          key={uuidv4()}
          className={`BreadCrumbTitle ${
            (i.type === "link" || i.type === "tab") && "ActivePage"
          }`}
          onClick={() => {
            navigate(i.link);
            if (i.type === "tab") {
              if (i.page === "products") {
                dispatch(
                  updateProductParams({
                    isCategoryPage: false,
                    tab: i.tab,
                  })
                );
              }
              if (i.page === "influencers") {
                dispatch(updateInfluencerParams({ tab: i.tab }));
              }
              if (i.page === "videos" || i.page === "published") {
                if (i.tab === "Campaigns") {
                  // From video details page when on campaign, Show campaign list
                  navigate("/videos/campaigns")
                  dispatch(
                    updateVideoPageState({
                      isCategoryPage: false,
                      isCampaignListPage: true,
                    })
                  );
                } else {
                  dispatch(updateVideoParams({ tab: i.tab }));
                  dispatch(fetchNotes("video"));
                }
              }
              if (i.page === "report") {
                dispatch(updateTab(i.tab, true));
              }
            } else {
              if (i.page === "products") {
                dispatch(updateProductParams({ isCategoryPage: true }));
              }
              if (i.page === "influencers") {
                dispatch(updateInfluencerParams({ tab: "My Creators" }));
              }
              if (i.page === "videos") {
                dispatch(updateVideoPageState({ isCategoryPage: true }));
              }
              if (i.page === "published") {
                dispatch(updatePublishedPageState({ isCategoryPage: true }));
              }
            }
          }}
        >
          {i.name}
        </div>
      );
      arr.push(
        <div key={uuidv4()}>
          <img
            src={require("@images/videos/expand-right-icon.png").default}
            width={9}
          />
        </div>
      );
    });

    arr.push(
      <div key={uuidv4()}>
        <span className="ActiveTab">{recent && "Recent"} Video Details</span>
      </div>
    );

    return (
      <div
        className="IndexPageBreadCrumb"
        // style={isDetailPage ? { marginLeft: "42px" } : {}}
      >
        <div className="BreadCrumbContainer">{arr}</div>
      </div>
    );
  }

  return (
    <div className="IndexPageBreadCrumb">
      <div className="BreadCrumbContainer">
        <div
          className={`BreadCrumbTitle ${
            ActiveTab[indexName] === indexName ||
            !isCategoryActive[indexName] ||
            isDetailPage
              ? "ActivePage"
              : "InActivePage"
          }`}
          onClick={
            isDetailPage
              ? dispatchFromDetails[indexName]
              : dispatchActiveParams[indexName]
          }
        >
          {renderIndexName()}
        </div>
        {campaignBreadcrumbs.length > 0 ? (
          <CampaignBreadcrumbs />
        ) : isDetailPage ? (
          renderDetailsCrumbs
        ) : (
          renderIndexCrumbs
        )}
      </div>
    </div>
  );
};
export default GenerateBreadCrumbs;
